module.exports = __webpack_public_path__ + "static/media/simile-logo.8bebaa74.svg";